// 业务系统错误代码
export const CODE_UNAUTHENTICATED = 12001 // 未登录认证
export const CODE_UNAUTHORIZATION = 12003 // 没有权限
export const CODE_VALIDATE_FAIL = 11000 // 表单数据校验不通过，在返回结构中可以从details属性获得校验的详细错误信息
